import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import {PAGE_ACTION_UNSUBSCRIBE, PREFERENCES_PAGE, UNSUBSCRIBE_PAGE_PRIMARY, UNSUBSCRIBE_PAGE_SECONDARY} from './constants'

const UnsubscribedTitle = styled.div`
  margin-bottom: 1.1em;
`

export const getHeaderCopy = action => {
  return action === PAGE_ACTION_UNSUBSCRIBE
      ? <Fragment>
        <UnsubscribedTitle>{UNSUBSCRIBE_PAGE_PRIMARY}</UnsubscribedTitle>{UNSUBSCRIBE_PAGE_SECONDARY}
      </Fragment>
      : PREFERENCES_PAGE;
}
